import { precogAccountingConstants } from "../../../actions/precog/accounting";
import { precogAccountedEntriesConstants } from "../../../actions/precog/accountedEntries";

const defaultState = null;

export function dashboardFilter(state = defaultState, { type, payload }) {
  switch (type) {  
  case precogAccountingConstants.SAVE_FILTER:
    return payload;
  default:
    return state;
  }
}

export function accountedEntriesFilter(state = defaultState, { type, payload }) {
  switch (type) {
  case precogAccountedEntriesConstants.SAVE_FILTER:
    return payload;
  default: 
    return state;
  }
}
